import styled, { css } from 'styled-components';

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: center;
  gap: 0.2rem;
  width: 25%;
  @media (max-width: 650px) {
    width: 40%;
  }
`;

export const Icon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  width: 40px;
  height: 40px;
  margin: 0 auto 10px auto;
  font-weight: 700;
  z-index: 1;
  background: ${({ $isActive }) => ($isActive ? '#00aeef' : '#eceff1')};
  color: ${({ $isActive }) => ($isActive ? '#ffffff' : '#8191ab')};
  ${({ $isCompleted }) =>
    $isCompleted &&
    css`
      background: #00aeef;
      background-image: url(data:image/svg+xml;base64,PHN2ZyBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDkuMTIgNyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTkuMTIgMS4wNkw4LjA2IDAgMy4xOCA0Ljg4IDEuMDYgMi43NiAwIDMuODIgMy4xOCA3bDUuOTQtNS45NHoiLz48L3N2Zz4=);
      color: transparent;
      background-size: 15px;
      background-repeat: no-repeat;
      background-position: center center;
    `};
`;

export const Line = styled.span`
  height: 4px;
  width: 100%;
  background: ${({ $isActiveOrCompleted }) => ($isActiveOrCompleted ? '#00aeef' : '#cfd8dc')};
  position: absolute;
  left: -50%;
  top: 20px;
`;

export const Label = styled.span`
  font-size: 14px;
  color: ${({ $isActiveOrCompleted }) => ($isActiveOrCompleted ? '#4f5e77' : '#8191ab')};
  opacity: ${({ $isActiveOrCompleted }) => ($isActiveOrCompleted ? 'unset' : 0.7)};
  font-weight: 500;
  word-spacing: 100vw;
`;
